import $ from 'jquery';

$( ".etichetta" ).on( "click", function() {
    if( $(this).next().innerHeight() > 0 ) {
        resetAccordion();
    } else {
        resetAccordion( $(this).index() / 2 );
        var var_height = $(this).next().children('.testo-container').innerHeight();
        $(this).addClass('open');
        $(this).next().css('height', var_height+'px');
    }
} );

function resetAccordion( excluded ) {
    if( excluded == undefined ) {
        $(".etichetta").removeClass('open');
        $('.testo-faq').each(function(i) { $(this).css('height','0px'); });
    } else {
        $('.etichetta').each(function(i) {
            if( i != excluded ) {
                $(this).removeClass('open');
            }
        });
        $('.testo-faq').each(function(i) {
            if( i != excluded ) {
                $(this).css('height','0px');
            }
        });
    }
}


// WEBPACK FOOTER //
// ../views/blocks/faqs/faqs.js